import { gql } from '@apollo/client';

export const QUERY_STANDARDIZED_ADDRESS = gql`
  query QueryStandardizedAddress($residentialAddress: String!) {
    queryStandardizedAddress(residentialAddress: $residentialAddress) {
      id
      residentialAddress
      standardAddress
      residentialName
      cityName
      stateAbbreviation
      zipcode
      residentialAddressHash
      images {
        id
        residentialAreaId
        imageS3Key
        stopNumber
        imageDisplayUrl
      }
    }
  }
`;

export interface AddressResidentialAreaImageType {
  id: string;
  residentialAreaId: number;
  imageS3Key: string;
  stopNumber: number;
  imageDisplayUrl?: string | null;
}

export interface QueryStandardizedAddressResponse {
  queryStandardizedAddress: {
    id: string;
    residentialAddress: string;
    standardAddress: string
    residentialName: string;
    cityName?: string | null;
    stateAbbreviation?: string | null;
    zipcode?: string | null;
    residentialAddressHash?: string | null;
    images?: AddressResidentialAreaImageType[] | null;
  } | null;
}
